module.exports = __webpack_public_path__ + "static/media/fast-reference.f1670cf8.svg";